
import { RootState, useAppDispatch, useAppSelector } from "../store";
import {
    setUserDetail as setUserDetailAction,
} from '../slices/userSlice';

// Not every component needs to dispatch actions individually; therefore, we create a common hook to handle dispatching.
export const useUpdateUserDetails = () => {
  const dispatch = useAppDispatch();
  function updateUserDetail(payload: any ) {
      dispatch(setUserDetailAction(payload));
  }


  return {
    updateUserDetail,
  };
};

// custom hook for accessing the data
export const useUserDetails= () => {
  return {
    userDetail: useAppSelector((state: RootState):any => {
      return state.userObject;
    })
  }
 
};